import React from "react";
import "./AirtableDashboard.css"; // Ensure you create this file

const AirtableDashboard = () => {
    return (
        <div className="airtable-container">
            <div className="airtable-card">
                <iframe
                    className="airtable-iframe"
                    src="https://airtable.com/embed/app5qz4J5oQ7bqTUo/shrZh6n9PVnYRV9Uy?viewControls=on"
                    title="TerrorStats"
                    width="100%"
                    height="700"
                ></iframe>
            </div>
        </div>
    );
};

export default AirtableDashboard;